<template>
  <div class="dialog_warp">
    <v-header>
        <span slot="title">{{info.buildName}} / {{info.floorName}} {{info.houseResName}}</span>
      </v-header>
    <div class="dialog_form" v-if="houseResType == 1">
      <div class="title">场地基本信息：</div>
      <div class="g-basic-data">
        场地面积:{{info.area}}㎡<span>场地状态：{{info.rentState|rentState}}</span>装修：{{info.fixState|fixState}}
      </div>
      <div class="title">租赁合同信息：</div>
      <el-table class="g-table flex-direction-box" :data="contracts" stripe
                style="width: 100%;overflow: hidden;max-height:100%;" size="mini">
        <template slot="empty">
          <el-button v-if="parkListLoading" type="text" :loading="true">加载中</el-button>
          <span v-if="!parkListLoading">暂无数据</span>
        </template>
        <el-table-column prop="zuhu" label="租户" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="statrtTime" label="计租日" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.statrtTime|datetimeType("yyyy-MM-dd")}}
          </template>
        </el-table-column>
        <el-table-column label="结束日" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.endTime|datetimeType("yyyy-MM-dd")}}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="f-prove-button" @click.stop="lookDetails(scope.row,scope.$index,1)">查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">物业合同信息：</div>
      <el-table class="g-table flex-direction-box" :data="propertyContracts" stripe
                style="width: 100%;overflow: hidden;max-height:100%;" size="mini">
        <template slot="empty">
          <el-button v-if="parkListLoading" type="text" :loading="true">加载中</el-button>
          <span v-if="!parkListLoading">暂无数据</span>
        </template>
        <el-table-column prop="zuhu" label="租户" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="statrtTime" label="计租日" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.statrtTime|datetimeType("yyyy-MM-dd")}}
          </template>
        </el-table-column>
        <el-table-column label="结束日" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.endTime|datetimeType("yyyy-MM-dd")}}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="f-prove-button" @click.stop="lookDetails(scope.row,scope.$index,2)">查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-center" style="margin-top:10px">
        <el-button size="small" class="f-search-btn g-success" type="success" @click.stop="close()">确认
          </el-button>
      </div>
    </div>
    <div class="dialog_form" v-if="houseResType == 2">
      <div class="title">场地基本信息</div>
      <div class="g-basic-data">
        房源面积:479㎡<span>房源状态：在租中</span>人才公寓类型：人才驿站<span>装修：简装</span>
      </div>
      <div class="title">公寓合同信息：</div>
      <el-table class="g-table flex-direction-box" :data="apartmentContracts" stripe
                style="width: 100%;overflow: hidden;max-height:100%;" size="mini">
        <template slot="empty">
          <el-button v-if="parkListLoading" type="text" :loading="true">加载中</el-button>
          <span v-if="!parkListLoading">暂无数据</span>
        </template>
        <el-table-column prop="zuhu" label="租户" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="statrtTime" label="计租日" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.statrtTime|datetimeType("yyyy-MM-dd")}}
          </template>
        </el-table-column>
        <el-table-column label="结束日" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.endTime|datetimeType("yyyy-MM-dd")}}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="f-prove-button" @click.stop="lookDetails(scope.row,scope.$index,3)">查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">住户信息：</div>
      <el-table class="g-table flex-direction-box" :data="apartmentContracts" stripe
                style="width: 100%;overflow: hidden;max-height:100%;" size="mini">
        <template slot="empty">
          <el-button v-if="parkListLoading" type="text" :loading="true">加载中</el-button>
          <span v-if="!parkListLoading">暂无数据</span>
        </template>
        <el-table-column prop="zuhulianxiren" label="入住人姓名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zuhuPhone" label="入住人联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zuhuIdCard" label="入住人联系方式" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="text-center" style="margin-top:10px">
        <el-button size="small" class="f-search-btn g-success" type="success" @click.stop="close()">确认
          </el-button>
      </div>
    </div>

    <el-dialog title="合同详情" class="contract-bill" :visible.sync="contractDialog" append-to-body width="750px" center top="3%">
      <v-contract-details v-if="contractDialog" @closeDialog="contractDialog = false" :contractId="contractId" :contractType="contractType" @init="init();contractDialog = false;"></v-contract-details>
    </el-dialog>

  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";
  export default {
    data() {
      return {
        info: {},
        fileList: [],
        submitLoading: false,
        conts: '',
        tableList:[],
        type:2,
        parkListLoading:false,
        apartmentContracts:[],
        contracts:[],
        propertyContracts:[],
        contractDialog:false,
        contractId:'',
        contractType:'',
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    computed: {},
    props:['houseResId','houseResType'],
    methods: {
      close(type) {
        if (type === 1) {
          this.$emit('init')
        } else {
          this.$emit('closeDialog')
        }
      },
      lookDetails(row, index,type){
        this.contractId = row.contractId;
        this.contractType = type;
        this.contractDialog = true;
      },
      init() {
        getData.houseResAreaDetail({houseResId:this.houseResId,type:this.houseResType}).then(res => {
          this.parkListLoading = false;
          if (res.data.code == "success") {
            this.info = res.data.data.data.mhHouseResVO;
            this.apartmentContracts = res.data.data.data.apartmentContracts;
            this.contracts = res.data.data.data.contracts;
            this.propertyContracts = res.data.data.data.propertyContracts;
          }
        }).catch(_ => {
          console.log(_);
          this.parkListLoading = false;
        });
      },
    },
    components: {},
    watch: {},
  }
</script>
<style lang="scss">
.contract-bill{
  .el-dialog__body{
    padding:0;
  }
}

</style>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .dialog_warp{
    padding: 0;
    margin:0;
    background: #fff;
  }
  .dialog_form {
    margin:0;
    padding: 10px;
    background: #f2f3f5;
  }
  .title{
    font-size:14px;
  }
  .g-basic-data{
    padding: 20px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }




</style>



// WEBPACK FOOTER //
// src/components/site-details.vue